import Axios, { AxiosError } from 'axios';
import eventEmitter from '../utils/eventEmitter';
import { authApi } from './authApi'; // Usaremos o authApi para tentar o refresh

/**
 * Define a baseURL para o Synthesis.
 * Ajuste conforme necessário para produção/desenvolvimento.
 */
function mountBaseUrlSynthesis() {
  const env = process.env.NODE_ENV;
  // Exemplo: Se rodar localmente na porta 8001
  if (env === 'development') {
    return 'http://localhost:8003/api';
  }
  // Exemplo: URL de produção
  return 'https://synthesis.publisol.com.br/api';
}

// Cria a instância do Axios para Synthesis
const synthesisApi = Axios.create({
  baseURL: mountBaseUrlSynthesis(),
  withCredentials: true, // Essencial para enviar o cookie 'access_token'
});

// Interceptor de resposta (similar aos outros services)
synthesisApi.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config;

    // Se for 401 e não for uma tentativa de retry
    if (error.response?.status === 401 && originalRequest && !(originalRequest as any)._retry) {
      (originalRequest as any)._retry = true; // Marca como tentativa
      try {
        // Tenta renovar o token usando o authApi (Connect)
        console.log('Attempting token refresh via authApi...');
        await authApi.post('/token/refresh/');
        console.log('Token refresh successful. Retrying original request to Synthesis...');
        // Reexecuta a requisição original para o Synthesis com o novo cookie
        return synthesisApi(originalRequest);
      } catch (refreshError: any) {
        console.error('Token refresh failed:', refreshError.response?.data || refreshError.message);
        // Se o refresh falhar, emite evento de logout
        eventEmitter.emit('logout');
        return Promise.reject(refreshError);
      }
    }

    // Se não for 401 ou já tentou retry, rejeita o erro
    return Promise.reject(error);
  },
);

export { synthesisApi };